/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// ---------------------------------------------------------------------------
// Pílula de status compartilhada do app.
//
// PROMOVIDA de pages/hr/Recruitment/components/StatusBadge.jsx em 2026-09-11,
// quando o EmployeeNameSearch (componente compartilhado) passou a exibir o
// status do funcionário — migrate-on-touch do FC7 §H.4: extrair, não copiar,
// e componente compartilhado não importa de dentro de um módulo. O arquivo do
// Recrutamento virou re-export deste; as pílulas específicas de lá
// (Stage/FinalOutcome/InterviewResult/JobOpeningStatus) seguem mapeando
// enum → variante + label e delegando a render aqui.
//
// Cai num neutro para valor desconhecido — nunca quebra.
// ---------------------------------------------------------------------------

const VARIANTS = {
   neutral: { bg: 'rgba(0,0,0,0.06)', border: 'rgba(0,0,0,0.15)', text: '#444' },
   blue: { bg: 'rgba(24,95,165,0.12)', border: 'rgba(24,95,165,0.35)', text: '#0C447C' },
   green: { bg: 'rgba(46,125,50,0.12)', border: 'rgba(46,125,50,0.35)', text: '#1b5e20' },
   amber: { bg: 'rgba(133,79,11,0.12)', border: 'rgba(133,79,11,0.35)', text: '#854F0B' },
   red: { bg: 'rgba(171,32,32,0.12)', border: 'rgba(171,32,32,0.35)', text: '#8a1f1f' },
};

// `sm` existe para listas densas (linha de autocomplete, célula de tabela
// apertada), onde o porte padrão rouba a atenção do texto principal.
const SIZES = {
   md: { padding: '4px 12px', font: '11.5px' },
   sm: { padding: '2px 7px', font: '10px' },
};

const Pill = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: ${({ $padding }) => $padding};
   border-radius: 999px;
   font-size: ${({ $font }) => $font};
   font-weight: 800;
   letter-spacing: 0.01em;
   border: 1px solid ${({ $border }) => $border};
   background: ${({ $bg }) => $bg};
   color: ${({ $text }) => $text};
   white-space: nowrap;
`;

export default function StatusBadge({ variant = 'neutral', size = 'md', children }) {
   const cfg = VARIANTS[variant] ?? VARIANTS.neutral;
   const dim = SIZES[size] ?? SIZES.md;
   return (
      <Pill
         $bg={cfg.bg}
         $border={cfg.border}
         $text={cfg.text}
         $padding={dim.padding}
         $font={dim.font}
      >
         {children}
      </Pill>
   );
}

StatusBadge.propTypes = {
   variant: PropTypes.oneOf(['neutral', 'blue', 'green', 'amber', 'red']),
   size: PropTypes.oneOf(['md', 'sm']),
   children: PropTypes.node,
};
